import { Route, Routes } from 'react-router-dom';

import CreateSecret from './createSecret/CreateSecret';
import DisplaySecret from './displaySecret/DisplaySecret';
// import TestComponent from './shared/TestComponent';

export const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<CreateSecret />} />
      {/* <Route path="/" element={<TestComponent />} />dd */}
      <Route path="/:format/:key/:password" element={<DisplaySecret />} />
      <Route path="/:format/:key" element={<DisplaySecret />} />
    </Routes>
  );
};
